import { render, staticRenderFns } from "./Dispatch.vue?vue&type=template&id=19632564&scoped=true&"
import script from "./Dispatch.vue?vue&type=script&lang=ts&"
export * from "./Dispatch.vue?vue&type=script&lang=ts&"
import style0 from "./Dispatch.vue?vue&type=style&index=0&id=19632564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19632564",
  null
  
)

export default component.exports